import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/**
 * The metal is blob voxels with the metallic material; each cell keeps its own colour (silver,
 * gold, copper) when it flows. The floor, rim and anything else are terrain and never move.
 */
export const FLOWING_METAL_LIQUID = liquidKind('blob', { material: 'metallic' })

/**
 * One frame of gravity (the melt button held): the change set of the metal that moved. A whole
 * hold is one undo step; the coalescer accumulates in place (a long hold is many frames).
 */
export const FLOWING_METAL_MELT = liquidSettleEvent('experience.flowing-metal.melt', FLOWING_METAL_LIQUID)

/** Reducer handlers for Liquid metal (`experience.flowing-metal.*`). */
export const eventHandlers = FLOWING_METAL_MELT.handlers
